import React, { useContext } from 'react';

import { Container } from 'components/common';
import { LangContext } from 'providers/LangProvider';
import map from 'assets/illustrations/vatnsnes-map.svg';
import { Details, HindisvikWrapper, MapFigure } from './styles';

export const Hindisvik = () => {
  const { lang } = useContext(LangContext);

  const headerText = lang === 'is' ? 'Jörðin' : 'The Farm';

  return (
    <section id="hindisvik">
      <HindisvikWrapper as={Container}>
        <Details>
          <h2>{headerText}</h2>
          {lang === 'is' ? (
            <>
              <p>
                Jörðin Hindisvík stendur yst á Vatnsnesi í Húnaþingi vestra og er kennd við samnefnda vík. Hún er falleg
                annesjajörð í miðjum Húnaflóa með sjónlínu beint í átt að norðurheimskautsbaug. Næsti kaupstaður,
                Hvammstangi, er miðstöð byggðarlagsins.
              </p>
              <p>
                <strong>Hindisvík er í einkaeign og eina jörðin á Íslandi sem ber þetta nafn.</strong>
              </p>
            </>
          ) : (
            <>
              <p>
                Hindisvík is a farm on the tip of Vatnsnes, a peninsula on the northwest coast of Iceland. It is
                situated in the middle of Húnaflói with a clear line of vision towards the Arctic Circle. Hvammstangi,
                the nearest town to Hindisvík, is the administrative centre of the area.
              </p>
              <p>
                <strong>Hindisvík is privately owned and the only farm in Iceland bearing that name.</strong>
              </p>
            </>
          )}
          <MapFigure>
            <img
              src={map}
              width="800"
              height="793"
              alt={
                lang === 'is'
                  ? 'Kort af Vatnsnesi. Hindisvík er yst á nesinu og Hvammstangi sunnar, við Miðfjörð.'
                  : 'Map of Vatnsnes. Hindisvík is at the tip of the peninsula, with Hvammstangi further south on Miðfjörður.'
              }
            />
            <figcaption>
              {lang === 'is' ? 'Kortagögn' : 'Map data'} ©{' '}
              <a href="https://www.openstreetmap.org/copyright" rel="noopener noreferrer" target="_blank">
                OpenStreetMap contributors
              </a>
            </figcaption>
          </MapFigure>
        </Details>
      </HindisvikWrapper>
    </section>
  );
};
